import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=e2e957e6&scoped=true"
import script from "./Crm.vue?vue&type=script&lang=js"
export * from "./Crm.vue?vue&type=script&lang=js"
import style0 from "./Crm.vue?vue&type=style&index=0&id=e2e957e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e957e6",
  null
  
)

export default component.exports